import Model from "./base/model";

class QuotationSolicitation extends Model{
  resourceName() {
    return "quotation_solicitations";
  }

  fields() {
    return {
      visible: "",
      bank_id: "",
      bank: {jsonApi: "hasOne", type: "fintechs"},
      documents: {jsonApi: "hasMany", type: "quotation_documents"},
      is_new: "",
      proposals: {jsonApi: "hasMany", type: "quotation_proposals"},
      status: {jsonApi: "hasMany", type: "solicitation_status"},
      last_active_status_id: "",
      quotation_type: "",
      quotation_id: "",
      bank_fantasy_name: "",
      transporter_id: "",
      chat_room_id: "",
      unread_messages_count: "",
      commercial_id: "",
      analyst_id: "",
      commercial: {jsonApi: "hasOne", type: "users"},
      analyst: {jsonApi: "hasOne", type: "users"},
      quotation: {jsonAPi:"hasOne", type:"quotations"},
      quotation_number: "",
      decline_message: "",
      has_new_proposal: "",
      accept_message: "",
    }
  }

  async update(id) {
    return this.request(
      this.resourceName() + "/" + id,
      "PATCH",
      {},
      {}
    );
  }
  async updateResponsible(id,data) {
    return this.request(
      this.resourceName() + "/responsible/" + id,
      "PATCH",
      {},
      data
    );
  }

  async accept(id) {
    return this.request(
      this.resourceName() + "/accept/" + id,
      "POST",
      {},
      {}
    );
  }

  async refuse(id) {
    return this.request(
      this.resourceName() + "/refuse/" + id,
      "POST",
      {},
      {}
    );
  }

  async acceptProposal(id, data) {
    return this.request(
      this.resourceName() + "/accept_proposal/" + id,
      "POST",
      {},
      data,
    );
  }

  async refuseProposal(id, data) {
    return this.request(
      this.resourceName() + "/refuse_proposal/" + id,
      "POST",
      {},
      data,
    );
  }

  async analiseConcluida(id) {
    return this.request(
      this.resourceName() + "/analise/" + id,
      "POST",
      {},
      {},
    )
  }

  async processoConcluido(id) {
    return this.request(
      this.resourceName() + "/processo/" + id,
      "POST",
      {},
      {},
    )
  }
}

export default new QuotationSolicitation();
